<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/epidemic/epideAreaList' }">地区配置</el-breadcrumb-item>
            <el-breadcrumb-item>基础信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <el-form ref="formData" :model="formData" label-width="120px">
            <el-form-item label="国家名称：" disabled>{{countryName}}</el-form-item>

            <el-form-item label="风险等级：">
              <el-select v-model="formData.risk_level" clearable placeholder="请选择">
                <el-option
                  v-for="item in riskArr"
                  :key="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="风险等级描述：">
              <el-input
                v-model="formData.risk_desc"
                type="textarea"
                placeholder="请输入风险等级描述"
                :rows="5"
                style="width: 80%"
              ></el-input>
            </el-form-item>
          
            <el-form-item label="医疗资源：">
              <el-select v-model="formData.med_level" clearable placeholder="请选择">
                <el-option
                  v-for="item in medArr"
                  :key="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="医疗资源描述：">
              <el-input
                v-model="formData.med_desc"
                type="textarea"
                placeholder="请输入医疗资源描述"
                :rows="5"
                style="width: 80%"
              ></el-input>
            </el-form-item>

            <el-form-item label="封城情况：">
              <el-select v-model="formData.block_level" clearable placeholder="请选择">
                <el-option
                  v-for="item in blockArr"
                  :key="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="封城情况描述：">
              <el-input
                v-model="formData.block_desc"
                type="textarea"
                placeholder="请输入封城情况描述"
                :rows="5"
                style="width: 80%"
              ></el-input>
            </el-form-item>

            <el-form-item label="潜在风险：">
              <el-select v-model="formData.potential_risk_level" clearable placeholder="请选择">
                <el-option
                  v-for="item in potential_riskArr"
                  :key="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="潜在风险描述：">
              <el-input
                v-model="formData.potential_risk_desc"
                type="textarea"
                placeholder="请输入潜在风险描述"
                :rows="5"
                style="width: 80%"
              ></el-input>
            </el-form-item>

            <el-form-item label="国家群二维码">
              <img v-if="formData.qr_url" :src="formData.qr_url" style="width: 120px;height: 120px"/>
              <uploadFlie
                v-if="!formData.qr_url"
                ref="qrCode"
                imageType=".jpg,.jpeg,.png"
                :imageData="imageData"
                :imageUrl="imageUrl"
                :file-list="fileList"
              ></uploadFlie>
              <el-button v-if="formData.qr_url" type="primary" @click="formData.qr_url='' ">编辑</el-button>
            </el-form-item>

            <el-form-item label="紧急求助方式：">
              <div v-for="(item,index) in emergency_info" :key="index">
                <el-input v-model="emergency_info[index].unit" style="width:300px; margin-bottom: 20px"></el-input>
                <el-input
                  v-model="emergency_info[index].detail"
                  type="textarea"
                  placeholder="请输入紧急求助方式"
                  :rows="5"
                  style="width: 80%;margin-bottom: 20px"
                ></el-input>
              </div>
              <el-button type="primary" @click="helpAdd">添加</el-button>
            </el-form-item>

            <el-form-item label="地区：">
              <div v-for="(item,index) in areaObj" :key="index">
                <el-input v-model="areaObj[index].area" placeholder="请输入地区" style="width:200px; margin-bottom: 20px"></el-input>
                <el-select v-model="areaObj[index].level" clearable placeholder="请选择封城等级" style="margin-left: 10px">
                  <el-option
                    v-for="item in areaBlockArr"
                    :key="item.value"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-date-picker
                  v-model="areaObj[index].date"
                  type="date"
                  placeholder="选择日期"
                  style="margin-left: 10px">
                </el-date-picker>
                <el-input v-model="areaObj[index].tel" placeholder="请输入新冠热线电话" style="width:200px; margin-left: 10px"></el-input>
              </div>
              <el-button type="primary" @click="areaAdd">添加</el-button>
            </el-form-item>
         
            <el-form-item>
              <el-button type="primary" style="margin-top: 40px" @click="onSubmit">提交</el-button>
              <el-button @click="goBack">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadFlie from "@/components/unloadFile/index";
import api from "./api";
import tokenService from "@/utils/services/token_service";
import TipUtil from "@/utils/utils/TipUtil";

export default {
  components: { uploadFlie },
  data() {
    return {
      ids: this.$route.query.id,
      riskArr: [{
        value: '高'
      }, {
        value: '中',
      }, {
        value: '低',
      }],
      medArr: [{
        value: '紧缺'
      }, {
        value: '饱和',
      }, {
        value: '空余',
      }],
      blockArr: [{
        value: '全国封城'
      }, {
        value: '部分地区',
      }, {
        value: '未封锁',
      }],
      potential_riskArr: [{
        value: '高'
      }, {
        value: '中',
      }, {
        value: '低',
      }],
      areaBlockArr: [{
        value: '全地区封锁'
      }, {
        value: '部分城市封锁',
      }, {
        value: '未封锁',
      },{
        value: '未知',
      }],
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "yq"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      fileList: [], //文件列表
      ruleForm: {
        dialogImageUrl: "" //预览地址
      },
      emergency_info: [
        { unit: "", detail: "" }
      ],
      areaObj: [
        { area: "", level: "", date: "", tel: "" }
      ],
      countryName: "",
      formData: {
        //参数
       
      }
    };
  },
  created() {
    this.epidemicBase()
  },
  methods: {
    async epidemicBase() {
      let res = await api.epidemicBase({
        id: this.ids
      })
      this.countryName = res.info.area_name
      this.formData = res.info
      this.fileList.push({ url: this.formData.qr_url})
      this.emergency_info = this.formData.emergency_info_data || [{ unit: "", detail: "" }]
      this.areaObj = this.formData.block_info_data || [{ area: "", level: "", date: "", tel: "" }]
    },
    // 紧急求助 add
    helpAdd() {
      this.emergency_info.push({ unit: "", detail: "" })
    },
    // 地区 add 
    areaAdd() {
      this.areaObj.push({ area: "", level: "", date: "", tel: "" })
    },
    // 提交表单
    async onSubmit() {
      this.formData.emergency_info = JSON.stringify(this.emergency_info)
      this.formData.block_info = JSON.stringify(this.areaObj)
      if(this.formData.qr_url == "") {
        this.formData.qr_url = this.$refs.qrCode.UploadImageUrl
      }
      this.formData.id = this.ids
      delete this.formData.emergency_info_data
      delete this.formData.block_info_data
      let res = await api.areaFormSubmit(this.formData)
      if(res.error_code == 0) {
        TipUtil.message("信息提交成功！！", "success");
        this.$router.push("/epidemic/epideAreaList");
      }
    },

    // 取消跳转原页面
    goBack() {
      this.$router.push("/epidemic/epideAreaList");
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
.headContainer {
  height: 100vh;
  overflow-x: hidden;
}
</style>